import { AIConfig } from "./types";

// 默认AI配置
export const defaultAIConfig: AIConfig = {
  apiKey: "83580365-9157-469a-b743-16e225ae1ff2",
  baseURL: "https://ark.cn-beijing.volces.com/api/v3",
  model: "doubao-seed-1.6-250615",
  maxTokens: 2048,
  temperature: 0.7,
  maxConversationRounds: 50, // 支持50轮对话
};

// 环境变量配置说明
export const ENV_CONFIG_GUIDE = {
  VITE_DOUBAO_API_KEY: "豆包API密钥，从火山引擎控制台获取",
  VITE_DOUBAO_BASE_URL: "豆包API基础URL，默认为火山引擎地址",
} as const;

/**
 * 验证AI配置
 */
export function validateAIConfig(config: AIConfig): {
  valid: boolean;
  errors: string[];
} {
  const errors: string[] = [];

  if (!config.apiKey) {
    errors.push("API密钥不能为空");
  }

  if (!config.baseURL) {
    errors.push("API基础URL不能为空");
  }

  if (config.maxTokens <= 0) {
    errors.push("最大token数必须大于0");
  }

  if (config.temperature < 0 || config.temperature > 2) {
    errors.push("温度参数必须在0-2之间");
  }

  if (config.maxConversationRounds <= 0 || config.maxConversationRounds > 100) {
    errors.push("对话轮次必须在1-100之间");
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}

/**
 * 获取运行时AI配置
 */
export function getRuntimeAIConfig(): AIConfig {
  return {
    ...defaultAIConfig,
    apiKey: import.meta.env.VITE_DOUBAO_API_KEY || defaultAIConfig.apiKey,
    baseURL: import.meta.env.VITE_DOUBAO_BASE_URL || defaultAIConfig.baseURL,
  };
}
